// Pure logic for plan limits (Spec: docs/superpowers/specs/2026-07-08-stripe-plans-limits-design.md).
// null = unlimited. Effective limit: override -> plan -> null.

const LIMIT_KEYS = ['limit_projects', 'limit_pages_per_project', 'limit_users'];

export function effectiveLimits(plan, limitsOverride) {
  const override = limitsOverride || {};
  const planLimits = plan || {};
  const result = {};
  LIMIT_KEYS.forEach((key) => {
    if (override[key] !== undefined && override[key] !== null) {
      result[key] = override[key];
    } else if (planLimits[key] !== undefined && planLimits[key] !== null) {
      result[key] = planLimits[key];
    } else {
      result[key] = null;
    }
  });
  return result;
}

export function canCreate(count, limit) {
  return limit === null || count < limit;
}

export function parseLimitExceededError(error) {
  if (!error) return null;
  let haystack = '';
  try {
    haystack = JSON.stringify({
      message: error.message,
      graphQLErrors: error.graphQLErrors,
      networkError: error.networkError && error.networkError.message,
    });
  } catch (e) {
    haystack = String(error.message || error);
  }
  const match = /limit-exceeded:(projects|pages|users)/.exec(haystack);
  return match ? match[1] : null;
}

export function applyPlanFeatures(settings, features) {
  return { ...(settings || {}), ...(features || {}) };
}
